import React from "react";
import {
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";

import useFeatureFlags from "@/hooks/useFeatureFlag";
import { useHasSessionReplayHeatmapsEntitlement } from "@/sessionReplay/useHasSessionReplayHeatmapsEntitlement";

import { getRoleOptions } from "./roleOptions";

// Mirrors the `bold` rule in TeamPage's useModalStyles. Declared locally so this
// component doesn't import back into TeamPage.jsx, which would close an import
// cycle and drag the whole page into any test that renders the selector.
const useStyles = makeStyles({
  bold: {
    fontWeight: 550,
  },
});

type RoleSelectorProps = {
  defaultRole: string;
  onRoleChange: (role: string) => void;
};

function RoleSelector({ defaultRole, onRoleChange }: RoleSelectorProps) {
  const classes = useStyles();
  const flag = useFeatureFlags();
  const { hasEntitlement } = useHasSessionReplayHeatmapsEntitlement();

  return (
    <div>
      <FormLabel id="radio-role-select" className={clsx(classes.bold)}>
        Role
      </FormLabel>
      <RadioGroup
        defaultValue={defaultRole}
        aria-label="role-select"
        name="role-select"
        onChange={(_, value) => {
          onRoleChange(value);
        }}
      >
        {getRoleOptions().map((roleOption) => {
          return (
            <div key={roleOption.value}>
              <FormControlLabel
                value={roleOption.value}
                control={<Radio />}
                label={roleOption.label}
                style={{ marginBottom: "0px", paddingBottom: "0px" }}
              />
              <FormHelperText
                style={{
                  marginTop: "-10px",
                  marginBottom: "5px",
                  paddingBottom: "5px",
                  paddingLeft: "30px",
                  fontSize: "0.8em",
                }}
              >
                {roleOption.description(flag, hasEntitlement)}
              </FormHelperText>
            </div>
          );
        })}
      </RadioGroup>
    </div>
  );
}

export default RoleSelector;
